import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
  ligas: [],
  liga: {}
};

export const mutations = {
  ADD_LIGA(state, liga) {
    state.ligas.push(liga);
  },
  SET_LIGAS(state, ligas) {
    state.ligas = ligas;
  },
  SET_LIGA(state, liga) {
    state.liga = liga;
  }
};

export const actions = {
  fetchLigas({ commit, dispatch }, equipos = false) {
    QuinielazoService.getLigas(equipos)
      .then(resp => {
        commit("SET_LIGAS", resp.data);
      })
      .catch(err => {
        const notification = {
          type: "error",
          message: "Hubo un problema leyendo las ligas: " + err.message
        };
        dispatch("notification/add", notification, { root: true });
        //console.log(err)
      });
  },
  createLiga({ commit, rootState, dispatch }, liga) {
    console.log("Usuario creando Liga es " + rootState.user.user.name);

    return QuinielazoService.postLiga(liga)
      .then(resp => {
        console.log(resp);
        commit("ADD_LIGA", liga);
        const notification = {
          type: "success",
          message: "Se agrego la liga"
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch(err => {
        const notification = {
          type: "error",
          message: "Hubo un problema al crear la liga " + err.message
        };
        dispatch("notification/add", notification, { root: true });
      });
  },
  fetchLiga({ commit, getters, dispatch }, id) {
    var liga = getters.getLigaById(id);

    if (liga) {
      commit("SET_LIGA", liga);
    } else {
      QuinielazoService.getLiga(id)
        .then(resp => {
          commit("SET_LIGA", resp.data);
        })
        .catch(error => {
          const notification = {
            type: "error",
            message: "Hubo un problema al crear la liga " + error.message
          };
          dispatch("notification/add", notification, { root: true });
        });
    }
  },
  updateLiga({ commit, dispatch }, liga) {
    return QuinielazoService.updateLiga(liga)
      .then(() => {
        commit("SET_LIGA", liga);
        const notification = {
          type: "success",
          message: "Se actualizo la liga"
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch(error => {
        const notification = {
          type: "error",
          message: "Hubo un error al actualizar la liga" + error.message
        };
        dispatch("notification/add", notification, { root: true });
      });
  }
};

export const getters = {
  getLigaById: state => id => {
    return state.ligas.find(liga => liga.id === id);
  }
};
